export const getBackups = (state) => state.backups
export const getBackupDisks = (state) => state.backupDisks
export const getBackupDisksInfo = (state) => state.backupDisksInfo
